import React from 'react';

const RadioButton = ({id, name, value, handleOnClick, checkedValue, children, readOnly}) => {
  const handleOnCheckClick = (e) => {
    if(handleOnClick) handleOnClick(id, value);
  }


  const htmlId = `${id}_id`;
  const checked = checkedValue === value;

  return [<input type="radio" name={name} value={value} id={htmlId} checked={checked} readOnly={readOnly}
            onChange={handleOnCheckClick} key={`${id}_radio`}/>
          , <label className="mx radio" key={`${id}_label`}
                htmlFor={htmlId}>{children}</label>];
}

export default RadioButton;


// WEBPACK FOOTER //
// ./src/components/radioButton/index.js